module.exports = __webpack_public_path__ + "img/Advanced Search - Green.721391fe.png";